/**
 * 视频答题（vodQuestion）后台接口请求封装
 * 写法与工程既有封装 src/service/base_yun.js 一致：
 *   - Base URL 取自 service/api_header_config.js 的 api_header_epiboly（与 base_yun.js 同一来源）
 *   - axios 直调，仅在本模块的请求上附加 byId 请求头（登录后 user_info 存于 localStorage，含 id）
 * 请求路径统一加 /v3 前缀；统一返回 {code,statuscode,message,data,count}，业务失败 reject 带 message
 * 注：不修改 base_yun.js，不注册全局拦截器，不影响登录等其他请求
 */
import axios from 'axios'
import headerConfig from '../../../service/api_header_config'

const header = headerConfig.api_header
const API_PREFIX = '/v3'
// 导出 Excel 的下载地址（浏览器直接访问，不带请求头）
export const EXPORT_BASE = (header || '').replace(/\/+$/, '') + API_PREFIX

function resolveByid() {
  try {
    const ui = JSON.parse(window.localStorage.getItem('user_info') || 'null')
    if (ui && ui.id != null) return ui.id
  } catch (e) { /* 未登录/格式异常时用默认值 */ }
  return 1
}

// 统一业务判断：成功返回 body；失败 reject Error
function wrap(p) {
  return p.then(body => {
    if (!body) return Promise.reject(new Error('接口无返回，请确认服务已启动'))
    if (body.code === 0 || body.code === 200) return body
    return Promise.reject(new Error(body.message || '接口返回失败'))
  })
}

export function get(url, params) {
  return wrap(axios.get(header + API_PREFIX + url, {
    params,
    headers: { byId: resolveByid() }
  }).then(res => res.data))
}

export function post(url, data) {
  return wrap(axios.post(header + API_PREFIX + url, data, {
    headers: { byId: resolveByid() }
  }).then(res => res.data))
}

export function put(url, data) {
  return wrap(axios.put(header + API_PREFIX + url, data, {
    headers: { byId: resolveByid() }
  }).then(res => res.data))
}

export function del(url) {
  return wrap(axios.delete(header + API_PREFIX + url, {
    headers: { byId: resolveByid() }
  }).then(res => res.data))
}
